/**
 * Alternative to router.push to alleviate slow performance
 * @todo needs an alternative solution.  Suggest trying to fix with upgrade to Next v15
 */
export function windowRedirect(redirectTo: string) {
    window.location.assign(redirectTo);
}
